export class SubscribeApiModalHandler {
    /**
     * @property {HTMLElement} SubscribeApi.subscriptionModal
     * @property {HTMLElement} SubscribeApi.loadingOverlay
     * @param {HTMLElement} subscriptionModal
     * @param {HTMLElement} loadingOverlay
     */
    constructor(subscriptionModal, loadingOverlay) {
        this.subscriptionModal = subscriptionModal
        this.loadingOverlay = loadingOverlay
    }

    adjustModalForPendingKey() {
        $(this.subscriptionModal)
            .find(".subscriptionTextContainer")
            .html("Das Freischalten befindet sich bereits in Bearbeitung. Wir bitten um einen Moment Geduld.")
        $(this.subscriptionModal).find(".btnCancelSubscription").html("OK")
        $(this.subscriptionModal).find(".buy-coins-button").hide()
        $(this.subscriptionModal).modal("show")
        $(this.loadingOverlay).modal("hide")
    }

    adjustModalForAlreadyActiveAndCantBeRenewed() {
        $(this.subscriptionModal)
            .find(".subscriptionTextContainer")
            .html(
                "Du bist bereits Fan von diesem Star, eine Verlängerung deines Fan-Status ist zur Zeit nicht möglich.",
            )
        $(this.subscriptionModal)
            .find(".btnCancelSubscription")
            .html("Seite neu laden")
            .on("click", () => {
                window.location.reload()
            })
        $(this.subscriptionModal).find(".buy-coins-button").hide()
        $(this.subscriptionModal).modal("show")
        $(this.loadingOverlay).modal("hide")
    }

    adjustModalForTrialSubscriptionAlreadyActive() {
        $(this.subscriptionModal).find(".subscriptionTextContainer").html("Du bist bereits Fan von diesem Star.")
        $(this.subscriptionModal)
            .find(".btnCancelSubscription")
            .html("Seite neu laden")
            .on("click", () => {
                window.location.reload()
            })
        $(this.subscriptionModal).find(".buy-coins-button").hide()
        $(this.subscriptionModal).modal("show")
        $(this.loadingOverlay).modal("hide")
    }

    adjustModalForError() {
        $(this.subscriptionModal)
            .find(".subscriptionTextContainer")
            .html(
                "Dein Kaufvorgang konnte nicht bearbeitet werden. Falls dieses Problem längere Zeit bestehen bleibt, dann wende dich bitte an den technischen Support.",
            )
        $(this.subscriptionModal).find(".btnCancelSubscription").html("OK")
        $(this.subscriptionModal).find(".buy-coins-button").hide()
        $(this.subscriptionModal).modal("show")
        $(this.loadingOverlay).modal("hide")
    }
}
